import React from 'react';
import BeeSpinnerSVG from '@assets/bee_spinner.svg';
import classnames from 'classnames';
import styles from './circleSpinnerLoading.module.scss';

const CircleSpinnerLoading = ({ classNames = {} }) => {
  return (
    <div className={classNames.Container}>
      {/* <img
        src={BeeSpinnerSVG}
        alt="BeeSpinnerSVG"
        className={classnames(styles.CircleSpinner, classNames.Spinner)}
      /> */}
      <div className={classnames(styles.CircleSpinner, classNames.Spinner)} />
    </div>
  );
};

export default CircleSpinnerLoading;
